import React from 'react';
import { useTranslate } from '../../../components/TranslationText';
import { FormFileUpload } from '../../../components/FormInputs';
import EahsForm from '../../../components/EahsForm';

/**
 * Payment documents section for semen checkout.
 * Mirrors Flutter's PaymentDocumentsForm widget.
 *
 * Shows upload fields for:
 * - Payment Certificate
 * - Signed Contract
 *
 * Only rendered when order status is PendingPayment or files already exist.
 * Uses FormFileUpload connected to React Hook Form.
 */
export default function PaymentDocumentsForm({ disabled = false }) {
    const { translate } = useTranslate();

    return (
        <EahsForm title={translate('web.paymentDocuments', 'Payment Documents')}>
            <div className="col-lg-6 col-md-12 col-sm-12">
                <FormFileUpload
                    name="paymentCertificate"
                    label={translate('web.paymentCertificate', 'Payment Certificate')}
                    accept="image/*,application/pdf"
                    disabled={disabled}
                />
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
                <FormFileUpload
                    name="signedContract"
                    label={translate('web.signedContract', 'Signed Contract')}
                    accept="image/*,application/pdf"
                    disabled={disabled}
                />
            </div>
        </EahsForm>
    );
}
